// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3aYRq","left":"styles_left__2q95D"};